import React, { useEffect } from "react";
import { useLoggerStore } from "../../lib/store-logger";
// import { StreamingLog } from "../../multimodal-live-types";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
import "../../App.scss";
import { isServerContentMessage } from "../../multimodal-live-types";
import { isModelTurn } from "../../multimodal-live-types";

const LogDisplay: React.FC = () => {
  const { client } = useLiveAPIContext();
  const logs = useLoggerStore((state) => state.logs);
  const addLog = useLoggerStore((state) => state.log);

  useEffect(() => {
    const handleLog = (log: any) => {
        addLog(log);
    };

    client.on("log", handleLog);

    return () => {
      client.off("log", handleLog);
    };
  }, [client, addLog]);

  return (
    <div className="log-display">
      <h3>Logs</h3>
          {logs
              .filter(log => isServerContentMessage(log.message))
              .slice(-3) // Get the last 3 items

              .map((log, index) => (
                  <div key={index}>
                      <strong>{new Date(log.date).toLocaleTimeString()}:</strong>
                      {isServerContentMessage(log.message) &&
                          isModelTurn(log.message.serverContent) &&
                          <>
                              {log.message.serverContent.modelTurn.parts[0].text}
                              {log.message.serverContent.modelTurn.parts[0].text === "ALERT" && (
                                  <span style={{ color: 'red', marginLeft: '10px' }}>●</span>
                              )}
                          </>
                          
                          }

                  </div>
              ))}


    </div>
  );
};

export default LogDisplay;